import './styles/Footer.css';

function Footer() {

    return (
        <div className="footer">
            <div className="footer-top">
                <img src={'/denny logo.svg'} alt="Denny Logo"/>
                <p className="footer-body">For more than 70 years, DENNY has been a Proudly South African household name.</p>
                <div className="footer-links">
                    <div className="footer-nav">
                        <a href="/lets-cook" className="footer-link">Let's Cook</a> |
                        <a href="/recipes" className="footer-link">Recipes</a> |
                        <a href="/products" className="footer-link">Products</a> |
                        <a href="/about-us" className="footer-link">About Us</a> |
                        <a href="/fan-recipes" className="footer-link">Fan Recipes</a> |
                        <a href="/campaigns" className="footer-link">Campaigns</a> |
                        <a href="/blogs" className="footer-link">Blogs</a> |
                        <a href="/contact-us" className="footer-link">Contact Us</a>

                    </div>
                    <div className="footer-socials">
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://www.facebook.com/dennysouthafrica/',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="#022161" d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.6 1.6-1.6h1.7V4.8c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.5-4 4.2V11H8v3h2.7v8h2.8z"/>
                            </svg>
                        </div>
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://www.instagram.com/dennysouthafrica/',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="#022161" d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 3.5A4.5 4.5 0 1 0 16.5 12 4.5 4.5 0 0 0 12 7.5zm0 2A2.5 2.5 0 1 1 9.5 12 2.5 2.5 0 0 1 12 9.5zm5-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/>
                            </svg>
                        </div>
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://www.youtube.com/channel/UCaNSv69U1KKso7Zj800bR7A',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="#022161" d="M23 12s0-3.1-.4-4.5c-.2-.8-.9-1.5-1.7-1.7C19.5 5.4 12 5.4 12 5.4s-7.5 0-8.9.4c-.8.2-1.5.9-1.7 1.7C1 8.9 1 12 1 12s0 3.1.4 4.5c.2.8.9 1.5 1.7 1.7 1.4.4 8.9.4 8.9.4s7.5 0 8.9-.4c.8-.2 1.5-.9 1.7-1.7.4-1.4.4-4.5.4-4.5zm-13 3.2V8.8L16 12l-6 3.2z"/>
                            </svg>
                        </div>
                    </div>

                </div>
                <div className="footer-links-legal">
                <div className="footer-nav">
                    <a href="/privacy-policy" className="footer-link">Privacy Policy</a> |
                    <a href="/" className="footer-link">PAIA Manual</a> |
                    <a href="/" className="footer-link">Personal Information Protection Policy</a> |
                    <a href="/denny-cook-club-terms-conditions" className="footer-link">Terms & Conditions</a> |
                    <a href="/disclaimer" className="footer-link">Disclaimer</a>
                </div>
            </div>

            </div>
            <div className="footer-bottom">
                <div className="libstar-logo">
                    <a href="https://www.libstar.co.za/"
                       target="_blank" rel="noreferrer"><img src={"/libstar logo.svg"} alt={"Libstar Logo"} /> </a>
                </div>
                <div className="copyright-footer">
                    LEARN MORE AT{" "}
                    <a
                        href="https://www.libstar.co.za/"
                        target="_blank" rel="noreferrer"
                        className="libstar-link"

                    >
                        WWW.LIBSTAR.CO.ZA
                    </a>
                    {" | "}
                    ©{new Date().getFullYear()} COPYRIGHT OF DENNY®. | ALL RIGHTS RESERVED.
                </div>
            </div>
        </div>
    )
}

export default Footer;
